import { z } from "zod";
import { ValidatorInterface } from "../validator-interface";

export class MaxLengthValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const maxLength = parseInt(options.value, 10);
        const labelText = options.labelText || "This field";
        const message = options.message || `${labelText} must be no more than ${maxLength} characters`;

        if (isNaN(maxLength)) {
            // eslint-disable-next-line no-console
            console.warn("Invalid maxLength value provided for MaxLengthValidator:", options.value);
            return baseSchema; // Return base schema if maxLength is invalid
        }

        // Apply to string schemas
        if (baseSchema instanceof z.ZodString) {
            return baseSchema.max(maxLength, { message });
        }
        // Apply to array schemas
        else if (baseSchema instanceof z.ZodArray) {
            // Message might need adjustment for arrays
            const arrayMessage = options.message || `Please select no more than ${maxLength} item(s)`;
            return baseSchema.max(maxLength, { message: arrayMessage });
        }
        // Potentially other types like ZodSet?

        // eslint-disable-next-line no-console
        console.warn("MaxLengthValidator applied to unsupported schema type. Requires ZodString or ZodArray.");
        return baseSchema; // Return base schema if type is not supported
    }

    getErrorMessage(field, options = {}) {
        const maxLength = parseInt(options.value, 10);
        const labelText = options.labelText || "This field";
        if (isNaN(maxLength)) {
            return "Invalid maximum length requirement specified.";
        }
        // Consider field type for message (e.g., input vs select-multiple)
        const fieldType = field?.type;
        if (fieldType === "select-multiple") {
            return options.message || `Please select no more than ${maxLength} item(s)`;
        }
        return options.message || `${labelText} must be no more than ${maxLength} characters`;
    }
}
